module.exports = __webpack_public_path__ + "static/media/pin_idle_shadow.cd97b79b.png";